import * as React from 'react';
import { IconProps } from '../types';

const IcMoney = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M12.267 1.65h.104c.899 0 1.648 0 2.243.08.628.084 1.194.27 1.65.725.455.456.641 1.023.726 1.65.07.526.078 1.172.08 1.935h5a1.5 1.5 0 0 1 1.5 1.5v13.32a1.5 1.5 0 0 1-1.5 1.5H2.9a1.5 1.5 0 0 1-1.5-1.5V7.54a1.5 1.5 0 0 1 1.5-1.5h4.67c0-.763.009-1.41.08-1.935.084-.627.27-1.194.725-1.65.455-.455 1.022-.64 1.65-.725.595-.08 1.344-.08 2.242-.08Zm3.236 2.655c.056.42.065.965.066 1.735h-6.5c.002-.77.01-1.314.067-1.735.062-.461.17-.659.3-.789.13-.13.327-.238.789-.3.483-.065 1.13-.066 2.094-.066s1.612.002 2.095.066c.462.062.659.17.79.3.13.13.237.328.299.79Zm6.566 3.235H2.9v13.32h19.17V7.54Zm.002 13.32ZM13.07 10.4a.75.75 0 0 0-1.5 0v.01c-1.088.274-2 1.133-2 2.323 0 1.457 1.365 2.417 2.75 2.417.825 0 1.25.533 1.25.917s-.425.916-1.25.916c-.824 0-1.25-.532-1.25-.916a.75.75 0 0 0-1.5 0c0 1.19.912 2.048 2 2.323v.01a.75.75 0 0 0 1.5 0v-.01c1.09-.275 2-1.133 2-2.323 0-1.457-1.365-2.417-2.75-2.417-.824 0-1.25-.533-1.25-.917s.426-.916 1.25-.916c.825 0 1.25.532 1.25.916a.75.75 0 0 0 1.5 0c0-1.19-.91-2.049-2-2.323v-.01Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcMoney;
